import { AttachmentsForDialog } from '@qality/common-model';

export default {
  openAttachmentDialog(
    index: number,
    files: AttachmentsForDialog,
    isOpen: boolean
  ): void {
    window.AP.dialog.create({
      key: 'add-attachment-dialog',
      height: '100%',
      width: '100%',
      chrome: false,
      customData: {
        index,
        files,
        isOpen,
      },
    });
  },
};
